import { motion } from 'framer-motion';
import { personalInfo } from '../content/data';

const About = () => {
  return (
    <section id="about" className="section-padding">
      <div className="container-max">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-dm-sans font-bold text-text-slate dark:text-surface-white mb-4">
            About Me
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Hands-on Swiss stablecoin operations - from regulated CHFD infrastructure to Frankencoin merchant payments.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 max-w-2xl mx-auto">
            {personalInfo.focusAreas.map((area) => (
              <span
                key={area}
                className="px-3 py-1 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 text-xs sm:text-sm font-medium rounded-full"
              >
                {area}
              </span>
            ))}
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left Column - Bio */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-base sm:text-lg text-gray-600 dark:text-gray-300 leading-relaxed whitespace-pre-line">
              {personalInfo.bio}
            </p>

            {/* View full bio button - HIDDEN as requested */}
            {/* <motion.button
              whileHover={{ y: -2 }}
              whileTap={{ y: 0 }}
              className="btn-primary"
              onClick={() => window.open('/bio.pdf', '_blank')}
            >
              View full bio
            </motion.button> */}
          </motion.div>

          {/* Right Column - Key Highlights */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-lg sm:text-xl font-semibold text-text-slate dark:text-surface-white">
              Key Highlights
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {personalInfo.highlights.map((highlight, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-start space-x-3"
                >
                  <div className="w-2 h-2 bg-secondary-mint rounded-full flex-shrink-0 mt-2"></div>
                  <span 
                    className="text-sm sm:text-base text-gray-600 dark:text-gray-300"
                    dangerouslySetInnerHTML={{ __html: highlight }}
                  />
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
